//#region Imports
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { useLocation } from 'react-router-dom';
//MUI
import { Box } from '@mui/material';
import {
    formatDate
} from "../../../services/Functions";
//scss
import "../../../style/common.scss";
//jsbarcode
import warning from '../../../images/warning.png';
import { tableStyle, tableStyleOverDue } from '../../../style/common';
//pdfjs
import { useDispatch, useSelector } from 'react-redux';
import BasicTable from '../../../components/basicTable/basicTable';
import { fetchPaginatedEscalatedComplaints, firstPage as firstPageEscalated, lastPage as lastPageEscalated, nextPage as nextPageEscalated, previousPage as previousPageEscalated } from '../../../features/powerComplaints/escalatedComplaintsSlice';
import { fetchPaginatedPendingComplaints, firstPage as firstPagePending, lastPage as lastPagePending, nextPage as nextPagePending, previousPage as previousPagePending } from '../../../features/powerComplaints/pendingComplaintsSlice';
//#endregion

const PendingEscalatedTable = forwardRef((props, ref) => {

    //#region paginatedlogic
    const dispatch = useDispatch();
    const { pageNumber: pageNumberPending, pageSize: pageSizePending, status: complaintStatusPending, data: dataPending, totalPages: totalPagesPending, totalRecords: totalRecordsPending } = useSelector((state) => state.pendingComplaintsPaginated)
    const { pageNumber: pageNumberEscalated, pageSize: pageSizeEscalated, status: complaintStatusEscalated, data: dataEscalated, totalPages: totalPagesEscalated, totalRecords: totalRecordsEscalated } = useSelector((state) => state.escalatedComplaintsPaginated)

    const { token, userId, hierarchy, roleId, roleName, permissions, code: officeCode } = useSelector((state) => state.auth)

    const [viewBackdrop, setViewBackdrop] = useState(false);

    const handleNextPagePending = () => {
        setViewBackdrop(true)
        dispatch(nextPagePending());
    };

    const handlePreviousPagePending = () => {
        setViewBackdrop(true)
        dispatch(previousPagePending());
    };

    const handleFirstPagePending = () => {
        dispatch(firstPagePending());
    };

    const handleLastPagePending = () => {
        dispatch(lastPagePending(totalPagesPending)); // Replace '2' with actual value
    };

    const handleRowClick = async (applicationId, event) => {
        setViewBackdrop(true);
        let demandNoticeDetails = '';
        let dnPayDate = ''
        let scoDets = ''
        // if (applicationId) {
        //     if (item) {
        //         setViewBackdrop(false);
        //     }
        // }
    };

    const apiToDataGridConversionPending = () => {
        const tempArray = []
        if (powerComplaintsPending) {
            powerComplaintsPending.forEach((item) => {
                let dataGridObject = {}

                if (item.complaint.eOpsTrackingId) {
                    dataGridObject = {
                        "complaintId": item.complaint.eOpsTrackingId,
                        "refNo": item.complaint.refNo,
                        "tariff": item.complaint.tariff,
                        "name": item.complaint.name,
                        "address": item.complaint.address,
                        "registerdDateTime": formatDate(item.complaint.registeredAt),
                        "typeId": item.complaint.complaintType,
                        "phoneNo": item.complaint.mobile,
                        "billingMonth": item.complaint.billingMonth
                    }
                }
                tempArray.push(dataGridObject)
            })
        }
        else {
            const dataGridObject = {
                "complaintId": ' ',
                "refNo": '',
                "tariff": '',
                "typeId": '',
                "phoneNo": ' ',
                "billingMonth": ' ',

            }
            tempArray.push(dataGridObject)
        }
        setPowerComplaintsToDataGridPending(tempArray);
    }


    const handleNextPageEscalated = () => {
        setViewBackdrop(true)
        dispatch(nextPageEscalated());
    };

    const handlePreviousPageEscalated = () => {
        setViewBackdrop(true)
        dispatch(previousPageEscalated());
    };

    const handleFirstPageEscalated = () => {
        dispatch(firstPageEscalated());
    };

    const handleLastPageEscalated = () => {
        dispatch(lastPageEscalated(totalPagesEscalated)); // Replace '2' with actual value
    };


    const apiToDataGridConversionEscalated = () => {
        const tempArray = []
        if (powerComplaintsEscalated) {
            powerComplaintsEscalated.forEach((item) => {
                let dataGridObject = {}

                if (item.complaint.eOpsTrackingId) {
                    dataGridObject = {
                        "complaintId": item.complaint.eOpsTrackingId,
                        "refNo": item.complaint.refNo,
                        "tariff": item.complaint.tariff,
                        "name": item.complaint.name,
                        "address": item.complaint.address,
                        "registerdDateTime": formatDate(item.complaint.registeredAt),
                        "typeId": item.complaint.complaintType,
                        "phoneNo": item.complaint.mobile,
                        "billingMonth": item.complaint.billingMonth
                    }
                }
                tempArray.push(dataGridObject)
            })
        }
        else {
            const dataGridObject = {
                "complaintId": ' ',
                "refNo": '',
                "tariff": '',
                "typeId": '',
                "phoneNo": ' ',
                "billingMonth": ' ',

            }
            tempArray.push(dataGridObject)
        }
        setPowerComplaintsToDataGridEscalated(tempArray);
    }

    //#endregion

    const [powerComplaintsPending, setPowerComplaintsPending] = useState([]);
    const [powerComplaintsToDataGridPending, setPowerComplaintsToDataGridPending] = useState([]);
    const [powerComplaintsEscalated, setPowerComplaintsEscalated] = useState([]);
    const [powerComplaintsToDataGridEscalated, setPowerComplaintsToDataGridEscalated] = useState([]);

    //#region useEffects

    useEffect(() => {
        setViewBackdrop(true)
        dispatch(fetchPaginatedPendingComplaints({ pageNumber: pageNumberPending, pageSize: pageSizePending, subDivisionCode: officeCode, status: 'Pending' }));
    }, []);


    useEffect(() => {
        setViewBackdrop(true)
        dispatch(fetchPaginatedPendingComplaints({ pageNumber: pageNumberPending, pageSize: pageSizePending, subDivisionCode: officeCode, status: 'Pending' }));
    }, [pageNumberPending, pageSizePending]);

    useEffect(() => {
        if (dataPending) {
            setPowerComplaintsPending(dataPending)
            setViewBackdrop(false)
        }
    }, [dataPending])

    useEffect(() => {
        if (powerComplaintsPending) {
            apiToDataGridConversionPending()
        }
    }, [powerComplaintsPending]);



    useEffect(() => {
        setViewBackdrop(true)
        dispatch(fetchPaginatedEscalatedComplaints({ pageNumber: pageNumberEscalated, pageSize: pageSizeEscalated, subDivisionCode: officeCode, status: 'Escalated' }));
    }, []);


    useEffect(() => {
        setViewBackdrop(true)
        dispatch(fetchPaginatedEscalatedComplaints({ pageNumber: pageNumberEscalated, pageSize: pageSizeEscalated, subDivisionCode: officeCode, status: 'Escalated' }));
    }, [pageNumberEscalated, pageSizeEscalated]);

    useEffect(() => {
        if (dataEscalated) {
            setPowerComplaintsEscalated(dataEscalated)
            setViewBackdrop(false)
        }
    }, [dataEscalated])

    useEffect(() => {
        if (powerComplaintsEscalated) {
            apiToDataGridConversionEscalated()
        }
    }, [powerComplaintsEscalated]);
    //#endregion

    const tblColumnsPending = [
        { field: "complaintId", headerName: 'Complaint ID', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "refNo", headerName: 'Ref No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "name", headerName: 'Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "address", headerName: 'Address', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "phoneNo", headerName: ' Phone No.', disableColumnMenu: true, sortable: false, filterable: false, align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "registerdDateTime", headerName: 'Registered @', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    ]

    const tblColumnsEscalated = [
        { field: "complaintId", headerName: 'Complaint ID', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "refNo", headerName: 'Ref No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "name", headerName: 'Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "address", headerName: 'Address', align: 'left', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "phoneNo", headerName: ' Phone No.', disableColumnMenu: true, sortable: false, filterable: false, align: 'center', headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "registerdDateTime", headerName: 'Registered @', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
    ]

    useImperativeHandle(ref, () => ({
        handleRowClick
    }));

    const location = useLocation()
    const currentPath = location.pathname;

    return (
        <>
            {
                (props.showTable && currentPath == "/pending-escalated-complaints") &&
                <Box className='form-box'>
                    <div style={{ display: 'flex', flexDirection: "row" }}>
                        <Box className='application-table' style={{ marginRight: '10px' }}>
                            <h3 style={{ color: '#006ad1', marginBottom: '10px' }}>Pending Complaints</h3>
                            <div className='div-datagrid' >
                                <BasicTable
                                    columns={tblColumnsPending}
                                    data={powerComplaintsToDataGridPending}
                                    handleRowClick={(params) => handleRowClick(params.applicationId)}
                                    sx={tableStyle}
                                    rowHeight={37}
                                    pageSize={20}
                                    totalPages={totalPagesPending}
                                    totalRecords={totalRecordsPending}
                                    currentPage={pageNumberPending}
                                    // handleFilterDateFrom={handleDateFromFilterPending}
                                    // handleFilterDateTo={handleDateToFilterPending}
                                    // resetDateFilter={handleResetDateFilterPending}
                                    // handleFilterProgressId={handleProgressIdFilterPending}
                                    // handleFilterObjectionStatus={handleObjectionStatusFilterPending}
                                    // resetProgressIdFilter={handleResetProgressIdFilterPending}
                                    // resetObjectionStatusFilter={handleResetObjectionStatusFilterPending}
                                    firstPage={handleFirstPagePending}
                                    nextPage={handleNextPagePending}
                                    previousPage={handlePreviousPagePending}
                                    lastPage={handleLastPagePending}
                                    rowsPerPageOptions={[18, 30, 60]}
                                    rowsPageOption={false}
                                    getRowStyle={(params) => {
                                        return params.indexRelativeToCurrentPage % 2 === 0 ? tableStyle.evenRow : tableStyle.oddRow
                                    }}
                                />
                            </div>
                        </Box>
                        <Box className='application-table' >
                            <div style={{ display: 'flex', alignItems: 'end' }}>
                                <h3 style={{ color: '#9d192f', marginBottom: '10px' }}><img src={warning} alt='icon' style={{ width: '1vw', marginRight: '5px' }} />Escalated Complaints</h3>
                            </div>
                            <div className='div-datagrid' >
                                <BasicTable
                                    columns={tblColumnsEscalated}
                                    data={powerComplaintsToDataGridEscalated}
                                    handleRowClick={(params) => handleRowClick(params.applicationId)}
                                    sx={tableStyleOverDue}
                                    rowHeight={37.5}
                                    pageSize={20}
                                    firstPage={handleFirstPageEscalated}
                                    nextPage={handleNextPageEscalated}
                                    previousPage={handlePreviousPageEscalated}
                                    lastPage={handleLastPageEscalated}
                                    // handleFilterDateFrom={handleDateFromFilterOverdue}
                                    // handleFilterDateTo={handleDateToFilterOverdue}
                                    // resetDateFilter={handleResetDateFilterOverdue}
                                    // resetProgressIdFilter={handleResetProgressIdFilterOverdue}
                                    // resetObjectionStatusFilter={handleResetObjectionStatusFilterOverdue}
                                    // handleFilterProgressId={handleProgressIdFilterOverdue}
                                    // handleFilterObjectionStatus={handleObjectionStatusFilterOverdue}
                                    totalPages={totalPagesEscalated}
                                    totalRecords={totalRecordsEscalated}
                                    currentPage={pageNumberEscalated}
                                    rowsPerPageOptions={[18, 30, 60]}
                                    rowsPageOption={false}
                                    getRowStyle={(params) => {
                                        return params.indexRelativeToCurrentPage % 2 === 0 ? tableStyleOverDue.evenRow : tableStyleOverDue.oddRow
                                    }}
                                />
                            </div>
                        </Box>
                    </div>
                </Box>
            }
        </>
    )
})

export default PendingEscalatedTable;